import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
const FormSubscript = ({ children })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: "ptw-ml-3 ptw-text-body-sm ptw-text-surface-textSubdued",
        children: children
    });
const _components_FormSubscript = FormSubscript;
export { _components_FormSubscript as default };
